/** Host capabilities and play intent are separate: a web visitor can play a demo. */
export type RuntimeMode = 'web' | 'playables';

export interface RuntimeConfig {
  readonly runtimeMode: RuntimeMode;
  readonly demoRequested: boolean;
  readonly allowUploads: boolean;
  readonly allowChartEngine: boolean;
  readonly allowExternalMedia: boolean;
}

export function readRuntimeConfig(search: string, buildMode = 'web'): RuntimeConfig {
  const params = new URLSearchParams(search);
  // A Playables build cannot be turned back into an upload/API client by URL.
  const runtimeMode: RuntimeMode = buildMode === 'playables' || params.get('runtime') === 'playables'
    ? 'playables' : 'web';
  return Object.freeze({
    runtimeMode,
    demoRequested: params.get('demo') === '1' || runtimeMode === 'playables',
    allowUploads: runtimeMode === 'web',
    allowChartEngine: runtimeMode === 'web',
    allowExternalMedia: runtimeMode === 'web',
  });
}
